import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-consulta-veicular',
  templateUrl: './consulta-veicular.component.html',
  styleUrls: ['./consulta-veicular.component.scss']
})
export class ConsultaVeicularComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  menuItems = [
    { link: 'topico0', text: 'Agregado Veícular', active: true },
    { link: 'topico1', text: 'Cotação de Seguro', active: false },
    { link: 'topico2', text: 'Dados Históricos', active: false },
    { link: 'topico3', text: 'Histórico de Proprietários', active: false },
    { link: 'topico4', text: 'Localizador de Chassi e Motor', active: false },
    { link: 'topico5', text: 'Localizador de Placa', active: false },
    { link: 'topico6', text: 'Precificador', active: false },
    { link: 'topico7', text: 'Dados Estaduais', active: false },
    { link: 'topico8', text: 'Dados Nacionais', active: false },
    { link: 'topico9', text: 'Dados Judiciais Renajud', active: false },
    { link: 'topico10', text: 'Consulta CLRV - Documento', active: false },
    { link: 'topico11', text: 'VIN - Decode', active: false },
    { link: 'topico12', text: 'Gravame Simples - Detalhe do Financiamento', active: false },
    { link: 'topico13', text: 'Histórico de Roubo e Furto', active: false },
    { link: 'topico14', text: 'Histórico de Sinistro ', active: false },
    { link: 'topico15', text: 'Parecer Técnico', active: false },
    { link: 'topico16', text: 'Leilão complementar', active: false },
    { link: 'topico17', text: 'Veículos ofertados a leilão', active: false },
    { link: 'topico18', text: 'CNH', active: false },
    { link: 'topico19', text: 'Recall', active: false },
    { link: 'topico20', text: 'Histórico de Venda', active: false },
  ];


  topicos = [
    { id: 0, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t11.png'], botoes: null },
    { id: 1, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t12.png'], botoes: null },
    { id: 2, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t13.png'], botoes: null },
    { id: 3, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t14.png'], botoes: null },
    { id: 4, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t15.png'], botoes: null },
    { id: 5, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t16.png'], botoes: null },
    { id: 6, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t17.png'], botoes: null },
    { id: 7, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t18.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t1_n.jpg'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 8, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t9.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t2_n.jpg'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 9, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t110.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t3_n.jpg'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 10, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t111.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t4.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 11, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t112.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t5.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 12, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t113.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t6.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 13, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t114.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t7.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 14, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t115.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t8.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 15, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t116.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t12-1.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 16, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t117.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t9-1.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 17, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t118.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t10.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 18, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t119.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t11-1.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 19, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t120.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t13-1.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
    { id: 20, imagens: ['https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t121.png', 'https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/11/t14-1.png'], botoes: [{ id: 1, texto: 'Sem restrição', ativo: true }, { id: 2, texto: 'Com restrição', ativo: false }] },
  ];

  imgAtiva = {
    1: 1,
    2: 1,
    3: 1,
    4: 1,
    5: 1,
    6: 1,
    7: 1,
    8: 1,
    9: 1,
    10: 1,
    11: 1,
    12: 1,
    13: 1,
    14: 1,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 1,
    20: 1
  };

  mostraImagem(topicoId: number, imgId: number) {
    this.imgAtiva[topicoId] = imgId;

    const topico = this.topicos.find(t => t.id === topicoId);
    if (topico && topico.botoes) {
      topico.botoes.forEach(botao => botao.ativo = (botao.id === imgId));
    }
  }

  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.updateActiveMenuItem(id);
    }
  }

  updateActiveMenuItem(activeLink: string) {
    this.menuItems.forEach(item => item.active = (item.link === activeLink));
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {

    const distanciaDoTopo = 150;

    this.menuItems.forEach((item) => {
      const element = document.getElementById(item.link);
      if (element) {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;

        if (elementTop <= window.scrollY + distanciaDoTopo) {
          this.updateActiveMenuItem(item.link);
        }
      }
    });
  }

}
